import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Checkbox, DatePicker, Radio, Typography } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { DeleteOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonLink from 'components/theme_components/ButtonLink';
import Notification from 'components/theme_components/Notifications';
import { AuthContext } from 'components/Auth/Auth';
import { toDatePickerDate } from 'utils/utils2';
import { TpAuthorizationResponse } from 'services/thirdParty';
import Title from 'components/Title';
import { isBeforeDate } from 'utils/utilsSFS';
import moment from 'moment';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
export type AuthorizationActivityModalProps = {
  form: FormInstance;
  setVisible: (visible: boolean) => void;
  comcode: string;
  dataInput: TpAuthorizationResponse;
  onDone: any;
  loading: boolean;
  onCancel: any;
};

const TabUpdateStatusAuth = ({
  setVisible,
  comcode,
  dataInput,
  form,
  onDone,
  loading,
  onCancel,
}: AuthorizationActivityModalProps) => {
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);

  const { Title } = Typography;
  useEffect(() => {
    if (dataInput && dataInput.authDetail) {
      form.setFieldsValue({
        authid: dataInput.authid,
        event: 'TabUpdateStatusAuth',
        enddate: toDatePickerDate(dataInput.enddate),
        authstatus: dataInput.authstatus,
      });
    }
  }, [dataInput]);

  const validateFields = () => {
    form.validateFields().then(() => {
      onDone();
    });
  };
  return (
    <div>
      <FormInput
        name="authstatus"
        className="form-item no-border-radius ut-task-modal-title"
        labelCol={{ span: 16 }}
        labelAlign="left"
        rules={[{ required: true }]}
      >
        <Radio.Group className="ut-radio-group">
          <Radio value="ACTIVE"> Oui </Radio>
          <Radio value="INACTIVE"> Non </Radio>
        </Radio.Group>
      </FormInput>
      <FormInput
        name="enddate"
        className="form-item mb-7 ut-task-modal-label"
        layout="vertical"
        extra="JJ-MM-AAAA"
        rules={[{ required: true }]}
      >
        <DatePicker
          className="form-item no-border-radius"
          disabledDate={(d) =>
            isBeforeDate(
              d,
           moment(toDatePickerDate(dataInput.startdate))
            )
          }
          format={{
            format: 'DD-MM-YYYY',
            type: 'mask',
          }}
        />
      </FormInput>
      <Row justify={'end'} style={{ marginTop: 13 }}>
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          onClick={() => !isInspect && onCancel()}
        />
         <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn"
          onClick={() => !isInspect && setModalVisible(true)}
          iconPosition="end"
        />
        <ConfirmModal
          visible={modalVisible}
          status="error"
          message={
            'Souhaitez vous modifier la date de fin d’autorisation d’activité SVN ' +
            moment(dataInput.enddate).format('YYYY-MM-DD') +
            ' € à ' +
            moment(form.getFieldValue('enddate')).format('YYYY-MM-DD') +
            ' € ? '
          }
          onConfirm={() => {
            setModalVisible(false);
            validateFields();
          }}
          onCancel={() => !isInspect && setModalVisible(false)}
          className="modalConfirmOrCancel"
        />
      </Row>
    </div>
  );
};

export default TabUpdateStatusAuth;
